import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class ExpenseNotApprovedReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getInvoicedReportUrl:'/api/v1/portal/portal-admin/expense-not-approved-report',
            InvoicedJobsReportData:[],
            downloadReportName:'Expense Not Approved Report',
            selectedDrivers:[],
            drivers:[],
            // url: "/api/v1/portal/customers/all/for-dropdown-menu",
            url: "/api/v1/portal/drivers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((driver)=>{
                options.push({
                    label : driver.company.short_name+'-'+driver.first_name+' '+driver.last_name,
                    value : driver.driver.id
                });
            });
            this.setState({
              drivers: options,
              isLoading: false
            });
          });
        });
      }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedDrivers) {
        this.setState({selectedDrivers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getInvoicedReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            driver_ids: this.state.selectedDrivers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                InvoicedJobsReportData: response,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        filename = filename+" From "+moment(this.state.startDate).format("YYYY-MM-DD")+" To "+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
        let reportData = "";
        $('.daily-delivered-report-tbl tr').each(function () {
            $(this).find('td').each(function () {
                reportData = reportData + ($(this).text().replace(',', '')) + ',';
            });
            reportData = reportData + '\n';
        });
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let invoicedJobs = [];
        const {selectedDrivers} = this.state;
        let downloadableCsvDataInvoiced = "Job Ref, Reg/VIN, Driver Name, Expense Amount, Expense Type\n";
        if(this.state.InvoicedJobsReportData.length > 0){
            this.state.InvoicedJobsReportData.map((currentJob, index) => {
            let joburl = "/jobs/view/"+currentJob.job_id;
                invoicedJobs.push(
                    <tr key={index}>
                        <td className="job-ref-font16"><a href={joburl}>{currentJob.job_id}</a></td>
                        <td>{currentJob.registration_number != null ? currentJob.registration_number : currentJob.vin_number}</td>
                        <td>{currentJob.driver_name}</td>
                        <td>&pound;{currentJob.expenses_approval_price}</td> 
                        <td>{currentJob.expense_type}</td> 
                    </tr>
            );

            downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                            currentJob.job_id+','+
                                            (currentJob.registration_number != null ? currentJob.registration_number : currentJob.vin_number)+','+
                                            currentJob.driver_name+','+
                                            currentJob.expenses_approval_price+','+
                                            currentJob.expense_type+','+
                                            ''+"\n";
            });
        }else{
            invoicedJobs.push(
                <tr key='no-records'><td colSpan="26" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Expense Not Approved Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-4 col-sm-12">
                        <label><h5>Select Driver</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.drivers}
                                    selected={selectedDrivers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Drivers...",
                                            allItemsAreSelected: "All Drivers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Driver",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Expense Not Approved Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Expense Not Approved Report
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"><label className="alert alert-primary"><b>{this.state.InvoicedJobsReportData.length} jobs found..</b></label></div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Driver Name</th>
                                        <th>Expense Amount</th>
                                        <th>Expense Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="26"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    invoicedJobs
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-expense_not_approved_report')) {
    ReactDOM.render(
        <ExpenseNotApprovedReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-expense_not_approved_report')
    );
}